import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./terminalConsole.css";
import { QRCodeCanvas } from "qrcode.react";

// comps
import Calculator from "./modalBoxComps/Calculator";
import TestQr from "./testqr.png";

// MATERIAL UI ICONS
import SearchIcon from "@mui/icons-material/Search";
import LayersClearIcon from "@mui/icons-material/LayersClear";
import SettingsRemoteTwoToneIcon from "@mui/icons-material/SettingsRemoteTwoTone";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import SettingsIcon from "@mui/icons-material/Settings";
import CalculateIcon from "@mui/icons-material/Calculate";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import SmartButtonIcon from "@mui/icons-material/SmartButton";
import DiscountIcon from "@mui/icons-material/Discount";
import BroadcastOnHomeIcon from "@mui/icons-material/BroadcastOnHome";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import CloseIcon from "@mui/icons-material/Close";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AdjustIcon from "@mui/icons-material/Adjust";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ShareIcon from "@mui/icons-material/Share";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import BarcodeReaderIcon from "@mui/icons-material/BarcodeReader";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import MoveDownIcon from "@mui/icons-material/MoveDown";

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BackHandIcon from "@mui/icons-material/BackHand";
import SpeedIcon from "@mui/icons-material/Speed";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import RegisterDetailsComp from "./RegisterDetailsComp";
import ShareBillPOS from "./ware_house_comps/functional_comps/ShareBillPOS";
import POSThemeSwitcher from "./POSThemeSwitcher.jsx";

export default function TerminalConsole({
  posTheme,
  setPosTheme,
  companyData,
  addToCart,
  handleModalSwitch,
  toggleScreen,
  handleCloseRegister,
  registerClosing,
  setAlert,
  reveal,
  setReveal,
  cart,
  display,
  setDisplay, 
  toggleCloudScanner,
  scannerVisible
}) {
  function toggleDisplay(active) {
    if (display === active) {
      setDisplay("");
    } else {
      setDisplay(active);
    }
  }
  function controlReveal(active) {
    if (reveal === active) {
      setReveal("");
    } else {
      setReveal(active);
    }
  }

  const { registerData, itemsSoldCount } = useSelector(
    (state) => state.terminalActions,
  );

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setReveal("");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [setReveal]);

  return (
    <section id="terminalConsole" className=" fx-cl fx-jb space5">
      <div className="fx-cl space3">
        <div className="workflowItem TooltipWrapper">
          <button
            className={`workflowItemBtn fx-ac spacem ${reveal === "closeRegister" && "activeFlow"}`}
            onClick={() => controlReveal("closeRegister")}
          >
            {reveal === "closeRegister" ? (
              <CloseIcon fontSize="large" />
            ) : (
              <PowerSettingsNewIcon fontSize="large" />
            )}
          </button>
          <aside
            // ref={wrapperRef}
            // onClick={(e) => e.preventDefault()}
            className="workflowDisplayCont"
          >
            <RoundUpInfo
              companyData={companyData}
              registerData={registerData}
              handleCloseRegister={handleCloseRegister}
              registerClosing={registerClosing}
              setReveal={setReveal}
            />
          </aside>
          <div className="Tooltip TooltipLeft">Close Register</div>
        </div>
        <div className="fx-cl space1">
          <div className="workflowItem TooltipWrapper">
            <button
              className={`workflowItemBtn fx-ac spacem ${reveal === "reveal-products" && "activeFlow"}`}
              onClick={() => controlReveal("reveal-products")}
            >
              {reveal === "reveal-products" ? (
                <CloseIcon fontSize="large" />
              ) : (
                <StorefrontIcon fontSize="large" />
              )}
            </button>
            <aside
              // ref={wrapperRef}
              // onClick={(e) => e.preventDefault()}
              className="workflowDisplayCont"
            >
              <AllProducts
                addToCart={addToCart}
                setAlert={setAlert}
                setReveal={setReveal}
              />
            </aside>
            {reveal !== "reveal-products" && (
              <div className="Tooltip TooltipLeft">View Products</div>
            )}
          </div>
          <figure>
            <div className="workflowItem TooltipWrapper">
             <button
  className={`workflowItemBtn fx-ac spacem ${
    scannerVisible && "activeFlow"
  }`}
  onClick={toggleCloudScanner}
>
  {scannerVisible ? (
    <CloseIcon fontSize="large" />
  ) : (
    <BroadcastOnHomeIcon fontSize="large" />
  )}
</button>

            </div>
            <div className="workflowItem TooltipWrapper">
              <button
                className={`workflowItemBtn fx-ac spacem ${reveal === "layer6" && "activeFlow"}`}
                onClick={() => controlReveal("layer6")}
              >
                {reveal === "layer6" ? (
                  <CloseIcon fontSize="large" />
                ) : (
                  <SatelliteAltIcon fontSize="large" />
                )}
              </button>
              <aside className="workflowDisplayCont">Barcode Reader</aside>
              {reveal !== "layer6" && (
                <div className="Tooltip TooltipLeft">Input Barcode reader</div>
              )}
            </div>
            <div className="workflowItem TooltipWrapper">
              <button
                className={`workflowItemBtn fx-ac spacem ${reveal === "layer3" && "activeFlow"}`}
                onClick={() => controlReveal("layer3")}
              >
                {reveal === "layer3" ? (
                  <CloseIcon fontSize="large" />
                ) : (
                  <NotificationsActiveIcon fontSize="large" />
                )}
              </button>
              <aside className="workflowDisplayCont">No Notification yet</aside>
              {reveal !== "layer3" && (
                <div className="Tooltip TooltipLeft">Notification</div>
              )}
            </div>
            <div className="workflowItem TooltipWrapper">
              <button
                className={`workflowItemBtn fx-ac spacem ${reveal === "accept-return" && "activeFlow"}`}
                onClick={() => handleModalSwitch("accept-return")}
              >
                <MoveDownIcon fontSize="large" />
              </button>
              {/* <aside className="workflowDisplayCont"></aside> */}
              {reveal !== "accept-return" && (
                <div className="Tooltip TooltipLeft">Accept return</div>
              )}
            </div>
            <div className="workflowItem TooltipWrapper">
              <button
                className={`workflowItemBtn fx-ac spacem ${reveal === "layer4" && "activeFlow"}`}
                onClick={() => controlReveal("layer4")}
              >
                {reveal === "layer4" ? (
                  <CloseIcon fontSize="large" />
                ) : (
                  <ShareIcon fontSize="large" />
                )}
              </button>
              <aside
                id="shareBillMain"
                className="workflowDisplayCont"
                style={{
                  width: "48rem",
                  bottom: "-6rem",
                  top: "unset",
                  backgroundColor: "#f3f6ff",
                  color: "#062e6f",
                }}
              >
                <ShareBillPOS setAlert={setAlert} />
              </aside>
              {reveal !== "layer4" && (
                <div className="Tooltip TooltipLeft">Share transaction!</div>
              )}
            </div>
              <div className="workflowItem TooltipWrapper">
          <button
            className={`workflowItemBtn fx-ac spacem ${reveal === "calculator" && "activeFlow"}`}
            onClick={() => controlReveal("calculator")}
          >
            {reveal === "calculator" ? (
              <CloseIcon fontSize="large" />
            ) : (
              <CalculateIcon fontSize="large" />
            )}
          </button>
          <aside className="workflowDisplayCont workFlowCalculator">
            <Calculator />
          </aside>
          {reveal !== "layer7" && (
            <div className="Tooltip TooltipLeft">Calculator</div>
          )}
        </div>
          </figure>
          <div className="workflowItem TooltipWrapper">
            {cart.length > 0 ? (
              <button
                className="workflowItemBtn"
                style={{ backgroundColor: "#f85a38" }}
                onClick={() => handleModalSwitch("clear_cart")}
              >
                {reveal === "layer" ? (
                  <CloseIcon fontSize="large" />
                ) : (
                  <RemoveShoppingCartIcon fontSize="large" />
                )}
              </button>
            ) : (
              <button
                className="workflowItemBtn"
                style={{ cursor: "not-allowed", opacity: 0.5 }}
              >
                {reveal === "layer" ? (
                  <CloseIcon fontSize="large" />
                ) : (
                  <RemoveShoppingCartIcon fontSize="large" />
                )}
              </button>
            )}

            {/* <aside className="workflowDisplayCont">Thanks</aside> */}
            {reveal !== "layer5" && (
              <div className="Tooltip TooltipLeft">Clear Cart</div>
            )}
          </div>
        </div>
      </div>
      <div className="fx-cl space1">
        <div className="workflowItem TooltipWrapper">
            <button
              className="workflowItemBtn fx-ac fx-jc"
              onClick={() => handleModalSwitch("register-information")}
            >
              <WorkHistoryIcon fontSize="large" />
            </button>
            {reveal !== "layer8" && (
              <div className="Tooltip TooltipLeft">Register Data</div>
            )}
          </div> 
        <figure>
          

          <div className="workflowItem TooltipWrapper">
            <button
              className={`workflowItemBtn fx-ac spacem ${reveal === "layer11" && "activeFlow"}`}
              onClick={() => controlReveal("layer11")}
            >
              {reveal === "layer11" ? (
                <CloseIcon fontSize="large" />
              ) : (
                <SettingsIcon fontSize="large" />
              )}
            </button>

            <aside className="workflowDisplayCont pos-settings-panel">
              <div className="pos-settings-heading">Terminal settings</div>
              <button type="button" className="pos-settings-action fx-ac spacem" onClick={() => toggleScreen()}>
                <BroadcastOnHomeIcon fontSize="large" />
                <span>Switch terminal view</span>
              </button>
              <POSThemeSwitcher theme={posTheme} onChange={setPosTheme} />
            </aside>
            {reveal !== "layer9" && (
              <div className="Tooltip TooltipLeft">SETTINGS</div>
            )}
          </div>
           <div className="workflowItem TooltipWrapper">
          <button
            className={`workflowItemBtn fx-ac spacem ${reveal === "closeRegister" && "activeFlow"}`}
            onClick={() => controlReveal("closeRegister")}
          >
            {reveal === "closeRegister" ? (
              <CloseIcon fontSize="large" />
            ) : (
              <PowerSettingsNewIcon fontSize="large" />
            )}
          </button>
          <aside
            // ref={wrapperRef}
            // onClick={(e) => e.preventDefault()}
            className="workflowDisplayCont"
          >
            <RoundUpInfo
              companyData={companyData}
              registerData={registerData}
              handleCloseRegister={handleCloseRegister}
              registerClosing={registerClosing}
              setReveal={setReveal}
            />
          </aside>
          <div className="Tooltip TooltipLeft">Close Register</div>
        </div>
        </figure>
      </div>
    </section>
  );
}

function AllProducts({ addToCart, setAlert, setReveal, wrapperRef }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);

  // SELECTORS FROM REDUX

  const { products } = useSelector(
    (state) => state.terminalActions.inventoryPOS,
  );

  // ----------------------------------------------------

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      setFilteredProducts([]);
    } else {
      const filtered = products.filter(
        (product) =>
          product?.name.toLowerCase().includes(term.toLowerCase()) ||
          product?.barcode.includes(term),
      );
      setFilteredProducts(filtered);
    }
  };

  function switchProductView() {
    if (filteredProducts.length > 0) {
      return (
        <div className="workFlowProductsDisplay g g6 space1">
          {filteredProducts?.map((product, index) => {
            return (
              <div
                className={`workflowDisplayItem fx-cl ${product.inventories?.stock?.quantity < 1 && "exhusted"}`}
                key={index}
                onClick={() => {
                  addToCart(product);
                  setFilteredProducts("");
                  setSearchTerm("");
                }}
              >
                <div className="itemCardTop fx-ac fx-jc">
                  {/* <InsertDriveFileIcon style={{ fontSize: "2.7rem" }} /> */}
                  <div className="fx-cl spacem">
                    <h3 className="fs5 fw500 ">{product?.name}</h3>
                    <span>
                      Price: ₦
                      <strong>
                        {product?.pricing?.sellingPrice?.toLocaleString()}
                      </strong>
                    </span>
                  </div>
                  <span className="itemCardTopTag fs1 fw600">
                    Qty: {product?.stock?.sellingQuantity}
                  </span>
                </div>
                <div
                  className="itemCardBottom fx-cl space1"
                  style={{ flexGrow: 1 }}
                >
                  <div className="fx-cl spacem ">
                    <p>Brand: {product?.brand}</p>
                    <p>Unit: {product?.units?.baseUnit}</p>
                    {/* <span className=" fs1 fw600">
                      Selling Qty: {product?.stock?.sellingQuantity}
                    </span> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    } else if (searchTerm.trim() !== "") {
      return (
        <p className="no-products-found" style={{ color: "#fff" }}>
          No products found
        </p>
      );
    } else {
      return (
        <div className="workFlowProductsDisplay g g6 space1">
          {products?.map((product, index) => {
            return (
              <div
                className={`workflowDisplayItem fx-cl ${product.inventories?.stock?.quantity < 1 && "exhusted"}`}
                key={index}
                onClick={() => {
                  addToCart(product);
                  setFilteredProducts("");
                  setSearchTerm("");
                }}
              >
                <div className="itemCardTop fx-ac fx-jc">
                  {/* <InsertDriveFileIcon style={{ fontSize: "2.7rem" }} /> */}
                  <div className="fx-cl spacem">
                    <h3 className="fs5 fw500 ">{product?.name}</h3>
                    <span>
                      Price: ₦
                      <strong>
                        {product?.pricing?.sellingPrice?.toLocaleString()}
                      </strong>
                    </span>
                  </div>
                  <span className="itemCardTopTag fs1 fw600">
                    Qty: {product?.stock?.sellingQuantity}
                  </span>
                </div>
                <div
                  className="itemCardBottom fx-cl space1"
                  style={{ flexGrow: 1 }}
                >
                  <div className="fx-cl spacem ">
                    <p>Brand: {product?.brand}</p>
                    <p>Unit: {product?.units?.baseUnit}</p>
                    {/* <span className=" fs1 fw600">
                      Selling Qty: {product?.stock?.sellingQuantity}
                    </span> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
  }

  // TRIPPLE CLICKS TO CLOSE REVEALS
  useEffect(() => {
    const handleTripleClick = (event) => {
      // detail increments on rapid clicks (1 = single, 2 = double, 3 = triple)
      if (event.detail === 3) {
        setReveal("");
      }
    };

    window.addEventListener("click", handleTripleClick);

    return () => {
      window.removeEventListener("click", handleTripleClick);
    };
  }, [setReveal]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setReveal("");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [setReveal]);

  return (
    <div
      id="itemsContWrapper"
      className="fx-cl space1"
      style={{ position: "relative", padding: "0.7rem 1rem" }}
    >
      <div className="fx-cl space1">
        <div className="fx-ac fx-jb space2">
          <div className="fx-ac space2">
            <div
              className="workFlowSearchCont fx-ac space1"
              style={{
                border: " 2px solid #fff",
                borderRadius: "1rem",
              }}
            >
              <span className="fs4 fw500">
                Inventory Items : <strong>{products?.length}</strong>
              </span>
            </div>
            <div className="workFlowSearchCont tmlSerchItm fx-ac space1">
              <input
                type="text"
                placeholder="Search (/) for item by name, barcode..."
                value={searchTerm}
                onChange={handleSearch}
              />
              <div className="fx-ac space1">
                <SearchIcon fontSize="large" />
                <span className="fs4">Search</span>
              </div>
            </div>
          </div>
          <div className="fx-ac space1">
            <div
              className="workFlowSearchCont fx-ac space1"
              style={{ border: "none" }}
            >
              {/* Active items */}
              <div className="tooltipWrapper fx-ac space1 relative">
                <AutoAwesomeIcon fontSize="large" />
                <div className="Tooltip TooltipBottom">Active Items</div>
              </div>
              {/* Low Items */}

              <div className="tooltipWrapper fx-ac space1 relative">
                <SpeedIcon fontSize="large" />
                <div className="Tooltip TooltipBottom">Low items</div>
              </div>
              {/* Exhausted items */}
              <div className="tooltipWrapper fx-ac space1 relative">
                <BackHandIcon fontSize="large" />
                <div className="Tooltip TooltipBottom">Exhausted Items</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="fx">
          <button>Filter Search</button>
        </div> */}
      </div>

      <div className="workFlowProductsCont  fx-cl space1">
        <span style={{ fontSize: "1.6rem" }}>
          <strong>All Products</strong>
        </span>
        {switchProductView()}
      </div>
    </div>
  );
}

function RoundUpInfo({
  setReveal,
  handleCloseRegister,
  registerClosing,
  companyData,
  registerData,
}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setReveal("");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [setReveal]);

  return (
    <div className="roundUpRegister fx-cl space2">
      <div className="fx-ac space1">
        <SettingsRemoteTwoToneIcon />
        <h3>Register Closure</h3>
      </div>

      <div className="fx-cl space1">
        <h4>QR Code Details</h4>

        <div className="roundUpRegComp fx">
          <div className="regQrCont">
            <div className="fx-cl space1">
              <p>
                This QR code identifies the register. Its closure report is
                available to authorized accounts after the register is saved.
              </p>

              <p>
                The report includes transaction summaries, payment breakdowns,
                and reconciliation information for the current session.
              </p>
            </div>
            <div>
              <div className="regQr">
                <QRCodeCanvas
                  value={JSON.stringify({
                    registerId: registerData?.registerId || "",
                    representiveId: registerData?.representiveId || "",
                    companyName:
                      companyData?.businessProfile?.basicInfo?.businessName ||
                      "",
                    company_tel:
                      companyData?.businessProfile?.basicInfo?.business_tel ||
                      "",
                  })}
                  size={90}
                  // style={{ margin: "1rem" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fx-cl space1">
        <h4>Account Information</h4>

        <div className="roundUpRegComp fx">
          <div className="fx-cl space1">
            <p>
              The register will be closed under your account credentials. Your
              user ID, closure time, and reconciliation details will be recorded
              for auditing and reporting purposes.
            </p>
          </div>
        </div>
      </div>
      <div className="fx-cl space2">
        <p>
          Closing your register completes the current business session and locks
          the register from further sales transactions until the next opening
          session.
        </p>

        <p>
          Before proceeding, ensure all sales have been finalized, cash payments
          have been counted, and any pending transactions have been resolved.
        </p>

        <p>
          Once the register is closed, an end-of-day summary will be generated,
          providing a record of saved sales and payment breakdowns. Cash
          reconciliation is available when opening and counted cash are recorded.
        </p>
      </div>
      <div className="fx-cl space1">
        <h4>Close Register</h4>

        <div className="roundUpRegComp fx">
          <div className="roundUpClose fx-cl space1">
            <div className="fx-ac space4 fx-jb">
              <button onClick={() => setReveal("")}>Cancel</button>
              <button id="registerClose" disabled={registerClosing} onClick={() => handleCloseRegister()}>
                {registerClosing ? "Closing..." : "Close Register"}
              </button>
            </div>

            <p>
              Closing the register will finalize today's transactions and
              generate the end-of-day report. Ensure all cash and payment totals
              have been verified before continuing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
